<template>
    <div :class="{
          '_e-FormButtonOK--visible' : visible
        }" class="_e-FormButtonOK">
        <button @click="$emit('click')" class="_e-FormButtonOK__button">OK</button>
        <span class="_e-FormButtonOK__text">Appuyez sur ENTER</span>
    </div>
</template>
<script>
  export default {
    name: 'FormButtonOK',
    props: {
      visible: {type: Boolean, default: false},
    },
  };
</script>
<style scoped>
    ._e-FormButtonOK {
        position: relative;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        opacity: 0;
        transform: translateY(40px);
        transition: 400ms;
    }

    ._e-FormButtonOK--visible {
        transform: translateY(0);
        opacity: 1;
    }

    ._e-FormButtonOK__button {
        display: block;
        height: 30px;
        width: 70px;
        font-size: 20px;
        padding: 0 15px;
        margin-left: 3rem;
        background-color: rgb(255, 255, 255);
        color: rgb(128, 128, 128);
        margin-right: 25px;
        border: none;
        border-radius: 4px;
        cursor: pointer;
    }

    ._e-FormButtonOK__button:focus {
        outline: none;
    }

    ._e-FormButtonOK__text {
        font-size: 15px;
        font-weight: bold;
    }

</style>